import { style } from 'typestyle'
import { important } from 'csx'
export const primaryContrastMediumi = style({ color: important('white') })
